import { render, staticRenderFns } from "./ShipmentsNacex.vue?vue&type=template&id=83454f02"
import script from "./ShipmentsNacex.vue?vue&type=script&lang=js"
export * from "./ShipmentsNacex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports